// extracted by mini-css-extract-plugin
module.exports = {"section":"GuideContents_section__GtvvY","title":"GuideContents_title__p_Sba","body":"GuideContents_body__YrhZW","line":"GuideContents_line__qRmZw"};